import React from "react"
import { FormattedMessage } from "react-intl"

type Props = {
    label: FormattedMessage
    info: JSX.Element
}

const EventInfoBlock = (props: Props) => {
    return <div className={"mr-5"}>
        <div className={"w-100"}>
            <label className="col-form-label custom-form-label">
                <strong>
                    {props.label}
                </strong>
            </label>
        </div>
        {props.info}
    </div>
}

export default EventInfoBlock


// WEBPACK FOOTER //
// ./src/quote/analytics/events/Utils/EventInfoBlock.tsx